// AdAudit colours: blue = PPC, amber = GBP / Local SEO, emerald = SEO,
// orange = Shopping (as in the reports), rose = LSA, violet = keywords.
// Class names are written out in full so Tailwind can see them.

// Stat cards (Market Overview). "slate" is for non-channel totals.
export const STAT_CARD_COLORS = {
  blue: "border-blue-200 bg-blue-50 text-blue-700",
  amber: "border-amber-200 bg-amber-50 text-amber-700",
  emerald: "border-emerald-200 bg-emerald-50 text-emerald-700",
  purple: "border-purple-200 bg-purple-50 text-purple-700",
  rose: "border-rose-200 bg-rose-50 text-rose-700",
  slate: "border-slate-200 bg-white text-slate-700",
};

// Circular count badges in tables.
export const COUNT_BADGE_COLORS = {
  blue: "bg-blue-100 text-blue-700",
  amber: "bg-amber-100 text-amber-700",
  emerald: "bg-emerald-100 text-emerald-700",
  purple: "bg-purple-100 text-purple-700",
  rose: "bg-rose-100 text-rose-700",
};

// Channel name text (live preview while scanning).
export const CHANNEL_TEXT = {
  ppc: "text-blue-600",
  gbp: "text-amber-600",
  seo: "text-emerald-600",
  shopping: "text-orange-600",
  lsa: "text-rose-600",
};

// Small channel labels (Competitors table).
export const CHANNEL_BADGES = [
  { id: "ppc", label: "PPC", color: "bg-blue-100 text-blue-700" },
  { id: "gbp", label: "GBP", color: "bg-amber-100 text-amber-700" },
  { id: "seo", label: "SEO", color: "bg-emerald-100 text-emerald-700" },
  { id: "shopping", label: "Shop", color: "bg-orange-100 text-orange-700" },
  { id: "lsa", label: "LSA", color: "bg-rose-100 text-rose-700" },
];
